import { Component, input } from '@angular/core';
import { CustomerNavLink } from '../header.component';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'nav-link',
  imports: [
    RouterLink,
    RouterLinkActive
  ],
  templateUrl: './nav-link.component.html',
  styleUrl: './nav-link.component.scss'
})
export class NavLinkComponent {
  link = input.required<CustomerNavLink>();
  authUser = input<boolean>();
}
